export default "/_next/static/images/a2/3-a21ca923be0b892ee5511db544b96dc9.jpg";